import React from "react";

const Contact = () => {
  return <>Contact page</>;
};

export { Contact };
